export const TAB_CHANGE = 'TAB_CHANGE';
export const SET_BREAKDOWN = 'SET_BREAKDOWN';
export const SET_ACTIVE_BREAKDOWN_TAB_DETAILS = 'SET_ACTIVE_BREAKDOWN_TAB_DETAILS';
export const SAVE_VEHICLE_INSURANCE_INFO = 'SAVE_VEHICLE_INSURANCE_INFO';
export const SAVE_VEHICLE_COMPLIANCE_INFO = 'SAVE_VEHICLE_COMPLIANCE_INFO';
export const SHOW_VEHICLE_INSURANCE = 'SHOW_VEHICLE_INSURANCE';
export const SHOW_BREAKDOWN_SLIDEOUT = 'SHOW_BREAKDOWN_SLIDEOUT';
export const SHOW_CUSTOMER_INSIGHTS_SLIDEOUT = 'SHOW_CUSTOMER_INSIGHTS_SLIDEOUT';
export const DEAL_PULSE_SLIDEOUT_VIEWED = 'DEAL_PULSE_SLIDEOUT_VIEWED'; // dc-mv-306
export const SHOW_REPAIR_ORDERS_SLIDEOUT = 'SHOW_REPAIR_ORDERS_SLIDEOUT';
export const INCENTIVES_SLIDEOUT_TAB_CHANGE = 'INCENTIVES_SLIDEOUT_TAB_CHANGE';
export const SET_FUNCTIONS_MODAL = 'SET_FUNCTIONS_MODAL';
export const TOGGLE_RATE_TYPE = 'TOGGLE_RATE_TYPE';
export const SET_REFERENCE_RATE_TYPE = 'SET_REFERENCE_RATE_TYPE';
export const SET_AUDIT_LOG_SLIDEOUT = 'SET_AUDIT_LOG_SLIDEOUT';
export const COMPLIANCE_SLIDEOUT_TAB_CHANGE = 'COMPLIANCE_SLIDEOUT_TAB_CHANGE';
export const TRADE_IN_SLIDEOUT_TAB_CHANGE = 'TRADE_IN_SLIDEOUT_TAB_CHANGE';
export const SHOW_CREDIT_BUREAU = 'SHOW_CREDIT_BUREAU';
export const SET_IS_PAYMENT_CALL_PENDING = 'SET_IS_PAYMENT_CALL_PENDING';
export const SET_PAYMENT_IN_FLIGHT_COUNT = 'SET_PAYMENT_IN_FLIGHT_COUNT';
export const SET_IS_AUTOSELECT_PROGRAM_CHECKED = 'SET_IS_AUTOSELECT_PROGRAM_CHECKED';
export const SET_CALC_ENGINE_TRANSITION_STATE = 'SET_CALC_ENGINE_TRANSITION_STATE';
export const CLEAR_AIO_DXG_EVENT_ERRORS = 'CLEAR_AIO_DXG_EVENT_ERRORS';
export const DISMISS_FS_SYNC_FAILURE = 'DISMISS_FS_SYNC_FAILURE';
export const FS_SYNC_FINAL_ATTEMPT_TIMED_OUT = 'FS_SYNC_FINAL_ATTEMPT_TIMED_OUT';
export const OPEN_SLIDEOUT = 'OPEN_SLIDEOUT';
export const CLOSE_SLIDEOUT = 'CLOSE_SLIDEOUT';
export const SHOW_UPDATE_OFFER_FOR_FS_EVENTS = 'SHOW_UPDATE_OFFER_FOR_FS_EVENTS';
export const UPDATE_DEFERRED_DOWN_PAYMENT = 'UPDATE_DEFERRED_DOWN_PAYMENT';

// Pending Navigation Action Types
export const SET_PENDING_NAVIGATION = 'SET_PENDING_NAVIGATION';
export const CLEAR_PENDING_NAVIGATION = 'CLEAR_PENDING_NAVIGATION';

// Right To Cancel Action Types
export const UPDATE_RIGHT_TO_CANCEL_DAYS = 'UPDATE_RIGHT_TO_CANCEL_DAYS';
export const UPDATE_RIGHT_TO_CANCEL_CHARGE = 'UPDATE_RIGHT_TO_CANCEL_CHARGE';
